import { Navigate, Route, Routes } from 'react-router-dom'
import { RequireAuth } from './components/RequireAuth'
import { SourceScopeGuard } from './components/SourceScopeGuard'
import { FabricaAnunciosPage } from './pages/FabricaAnunciosPage'
import { BiLayout } from './layout/BiLayout'
import { AgendaPage } from './pages/AgendaPage'
import { ClientesPage } from './pages/ClientesPage'
import { DashboardPage } from './pages/DashboardPage'
import { DespesasPage } from './pages/DespesasPage'
import { FiscalPage } from './pages/FiscalPage'
import { FretesPage } from './pages/FretesPage'
import { InsightsAlertasPage } from './pages/InsightsAlertasPage'
import { InsightsComercialPage } from './pages/InsightsComercialPage'
import { InsightsFinanceiroPage } from './pages/InsightsFinanceiroPage'
import { InsightsHomePage } from './pages/InsightsHomePage'
import { InsightsLogisticaPage } from './pages/InsightsLogisticaPage'
import { InsightsPrioridadesPage } from './pages/InsightsPrioridadesPage'
import { InsightsProdutosPage } from './pages/InsightsProdutosPage'
import { BuyBoxPage } from './pages/BuyBoxPage'
import { ConfiguracoesPage } from './pages/ConfiguracoesPage'
import { ForgotPasswordPage } from './pages/ForgotPasswordPage'
import { LoginPage } from './pages/LoginPage'
import { ResetPasswordPage } from './pages/ResetPasswordPage'
import { MarcasPage } from './pages/MarcasPage'
import { MargensPage } from './pages/MargensPage'
import { OperacoesPage } from './pages/OperacoesPage'
import { PagamentosPage } from './pages/PagamentosPage'
import { PedidosPage } from './pages/PedidosPage'
import { PerfilPage } from './pages/PerfilPage'
import { ProdutoPage } from './pages/ProdutoPage'
import { ProdutosPage } from './pages/ProdutosPage'
import { ReclamacoesPage } from './pages/ReclamacoesPage'
import { PromocoesPage } from './pages/PromocoesPage'
import { AdsPage } from './pages/AdsPage'
import { MargemAnunciosPage } from './pages/MargemAnunciosPage'
import { EstoqueFullPage } from './pages/EstoqueFullPage'
import { NatalPage } from './pages/NatalPage'
import { ExpedicaoPage } from './pages/ExpedicaoPage'
import { FabricaVideosPage } from './pages/FabricaVideosPage'
import { AgentesPage } from './pages/AgentesPage'
import { RecompraPage } from './pages/RecompraPage'
import { VigiaEsgotadosPage } from './pages/VigiaEsgotadosPage'
import { ScoreAnunciosPage } from './pages/ScoreAnunciosPage'
import { ValidadorAnunciosPage } from './pages/ValidadorAnunciosPage'
import { UsuariosPage } from './pages/UsuariosPage'
import { BiDataProvider } from './state/BiDataContext'
import { BiSourceProvider } from './state/BiSourceContext'
import { BiUiVisibilityProvider } from './state/BiUiVisibilityContext'
import { PanelInsightsProvider } from './state/PanelInsightsContext'

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/esqueci-senha" element={<ForgotPasswordPage />} />
      <Route path="/redefinir-senha" element={<ResetPasswordPage />} />
      <Route element={<RequireAuth />}>
        <Route
          element={
            <BiUiVisibilityProvider>
              <BiSourceProvider>
                <BiDataProvider>
                  <PanelInsightsProvider>
                    <BiLayout />
                  </PanelInsightsProvider>
                </BiDataProvider>
              </BiSourceProvider>
            </BiUiVisibilityProvider>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="agenda" element={<AgendaPage />} />
          <Route path="usuarios" element={<UsuariosPage />} />
          <Route path="perfil" element={<PerfilPage />} />
          <Route path="configuracoes" element={<ConfiguracoesPage />} />
          <Route path="score-anuncios" element={<ScoreAnunciosPage />} />
          {/* fora do SourceScopeGuard: só fala com o serviço validador-anuncios (8107), não com as fontes do BI */}
          <Route path="validador-anuncios" element={<ValidadorAnunciosPage />} />
          <Route path="promocoes" element={<PromocoesPage />} />
          {/* fora do SourceScopeGuard: fala só com /api/ads do serviço 8101 (retrato da coleta de Product Ads) */}
          <Route path="ads" element={<AdsPage />} />
          {/* fora do SourceScopeGuard: lê o artifact do pipeline de margem, não as fontes do BI */}
          <Route path="margem-anuncios" element={<MargemAnunciosPage />} />
          {/* fora do SourceScopeGuard: JSON estático do motor estoque_full */}
          <Route path="estoque-full" element={<EstoqueFullPage />} />
          {/* fora do SourceScopeGuard: só fala com o serviço natal-2026 (8109) */}
          <Route path="natal-2026" element={<NatalPage />} />
          {/* fora do SourceScopeGuard: só fala com o serviço expedicao (8110) */}
          <Route path="expedicao" element={<ExpedicaoPage />} />
          {/* fora do SourceScopeGuard: fala só com o serviço fabrica-anuncios (API do ML + IA), não com as fontes do BI */}
          <Route path="fabrica-anuncios" element={<FabricaAnunciosPage />} />
          {/* fora do SourceScopeGuard: briefing de vídeo; a busca de anúncio no bridge é opcional */}
          <Route path="fabrica-videos" element={<FabricaVideosPage />} />
          {/* fora do SourceScopeGuard: só fala com o serviço agentes (8106) */}
          <Route path="agentes" element={<AgentesPage />} />
          <Route path="agentes/:agenteId" element={<AgentesPage />} />
          {/* fora do SourceScopeGuard: só fala com o serviço vigia-esgotados (8111) */}
          <Route path="vigia-esgotados" element={<VigiaEsgotadosPage />} />
          {/* "Vendas" saiu do menu em 22/09/2026 (decisão da Mariana): a Home É "Vendas Diárias",
              o painel por dia no modelo do Upseller. A rota antiga só redireciona. */}
          <Route path="vendas" element={<Navigate to="/" replace />} />
          <Route element={<SourceScopeGuard />}>
            <Route path="pedidos" element={<PedidosPage />} />
            <Route path="pagamentos" element={<PagamentosPage />} />
            <Route path="produtos" element={<ProdutosPage />} />
            <Route path="produtos/:sku" element={<ProdutoPage />} />
            <Route path="margens" element={<MargensPage />} />
            <Route path="fiscal" element={<FiscalPage />} />
            <Route path="fretes" element={<FretesPage />} />
            <Route path="despesas" element={<DespesasPage />} />
            <Route path="clientes" element={<ClientesPage />} />
            <Route path="operacoes" element={<OperacoesPage />} />
            <Route path="reclamacoes" element={<ReclamacoesPage />} />
            <Route path="recompra" element={<RecompraPage />} />
            <Route path="buybox" element={<BuyBoxPage />} />
            <Route path="marcas" element={<MarcasPage />} />
            <Route path="insights" element={<InsightsHomePage />} />
            <Route path="insights/alertas" element={<InsightsAlertasPage />} />
            <Route path="insights/prioridades" element={<InsightsPrioridadesPage />} />
            <Route path="insights/comercial" element={<InsightsComercialPage />} />
            <Route path="insights/produtos" element={<InsightsProdutosPage />} />
            <Route path="insights/logistica" element={<InsightsLogisticaPage />} />
            <Route path="insights/financeiro" element={<InsightsFinanceiroPage />} />
          </Route>
          <Route path="insights/mix" element={<Navigate to="/insights/produtos" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Route>
    </Routes>
  )
}
